<template>
  <div>
    <el-select
      v-close-on-zoom
      :value="state.selectedCallId"
      placeholder="Select callee"
      :disabled="readonly"
      class="call-select"
      @input="(callId) => selectCall(callId)"
    >
      <el-option
        v-for="call in emitter.caseConf.dialogue.calls"
        :key="call.id"
        :label="call.callee.en"
        :value="call.id"
      />
    </el-select>
    <unsolicited-items
      :emitter="emitter"
      :items="selectedCallItems"
      :selected="state.selectedItemId"
      :control="control"
      :readonly="readonly"
      @update="selectItem"
    />
    <wait-for-previous-checkbox
      :value="waitForPrevious"
      :disabled="readonly || !hasUnsolicitedPredecessor"
      @change="selectWaitForPrevious"
    />
  </div>
</template>

<script>
import get from 'lodash/get';

import UnsolicitedItems from './UnsolicitedItems.vue';
import WaitForPreviousCheckbox from './common/WaitForPreviousCheckbox.vue';
import waitForPreviousMixins from './mixins/WaitForPreviousMixins';

export default {
  name: 'unsolicited-callee-effect',
  components: {
    WaitForPreviousCheckbox,
    UnsolicitedItems,
  },
  mixins: [ waitForPreviousMixins ],
  props: ['readonly', 'emitter', 'ikey', 'getData', 'putData', 'control', 'type'],
  data() {
    return {
      state: {
        selectedCallId: null,
        selectedItemId: null,
      },
    };
  },

  computed: {
    // waitForPreviousMixins contract.
    waitForPreviousSpeaker() {
      return this.state.selectedCallId || null;
    },
    selectedCall() {
      const calls = get(this.emitter.caseConf, 'dialogue.calls', []);
      if (!calls) {
        return;
      }
      return calls.find((call) => call.id === this.state.selectedCallId);
    },
    selectedCallItems() {
      if (!this.selectedCall) {
        return [];
      }
      return this.selectedCall.unsolicited;
    },
  },
  created() {
    const data = this.getData(this.ikey);
    this.state.selectedCallId = get(data, 'callId');
    this.state.selectedItemId = get(data, 'id');
    this.loadWaitForPrevious(data);
  },
  mounted() {
    this.emitter.trigger('process', this.control);
  },
  methods: {
    selectCall(callId) {
      this.state.selectedCallId = callId;
      this.state.selectedItemId = null;
      // First time selecting a callee
      // We don't want to emit null id and
      // cause validation errors
      if (!this.getData(this.ikey)) {
        return;
      }
      this.update();
    },
    selectItem(itemId) {
      this.state.selectedItemId = itemId;
      this.update();
    },
    update() {
      this.putData(this.ikey, {
        type: 'UNSOLICITED_CALL',
        id: this.state.selectedItemId,
        callId: this.state.selectedCallId,
        // waitForPreviousMixins reconciles this value.
        waitForPrevious: this.waitForPrevious,
      });
      this.emitter.trigger('process', this.control);
    },
  },
}
</script>

<style scoped>

</style>